import { apiFetch } from './api';

export interface AdminStats {
  totalAgents: number;
  activeAgents: number;
  totalConversations: number;
  conversationsToday: number;
  totalLeads: number;
  leadsToday: number;
  totalUsers: number;
  activeUsers: number;
  newConversationsToday: number;
  completedConversationsToday: number;
  pendingConversations: number;
  highQualityLeads: number;
  mediumQualityLeads: number;
  lowQualityLeads: number;
}

export interface AgentStats {
  totalAgents: number;
  activeAgents: number;
  agentDetails: Array<{
    agentId: string;
    agentName: string;
    status: string;
    isActive: boolean;
    totalConversations: number;
    conversationsToday: number;
    totalLeads: number;
    leadsToday: number;
    lastActivity?: string;
  }>;
}

export interface ConversationStats {
  totalConversations: number;
  conversationsToday: number;
  conversationsYesterday: number;
  conversationsThisWeek: number;
  conversationsThisMonth: number;
  statusBreakdown: {
    naoAtendido: number;
    atendido: number;
    emAtendimento: number;
    finalizado: number;
  };
  typeBreakdown: {
    lead: number;
    cliente: number;
  };
}

export interface LeadStats {
  totalLeads: number;
  leadsToday: number;
  leadsYesterday: number;
  leadsThisWeek: number;
  leadsThisMonth: number;
  qualityBreakdown: {
    alta: number;
    media: number;
    baixa: number;
  };
  integrationStatus: {
    integrated: number;
    notIntegrated: number;
  };
}

export interface UserStats {
  totalUsers: number;
  activeUsers: number;
  inactiveUsers: number;
  usersThisWeek: number;
  usersThisMonth: number;
  roleBreakdown: {
    admin: number;
    sales: number;
    manager: number;
  };
}

export const adminStatsApi = {
  getOverviewStats: async (): Promise<AdminStats> => {
    return apiFetch<AdminStats>('/AdminStats/GetOverviewStats', { auth: true });
  },

  getAgentStats: async (): Promise<AgentStats> => {
    return apiFetch<AgentStats>('/AdminStats/GetAgentStats', { auth: true });
  },

  getConversationStats: async (): Promise<ConversationStats> => {
    return apiFetch<ConversationStats>('/AdminStats/GetConversationStats', { auth: true });
  },

  getLeadStats: async (): Promise<LeadStats> => {
    return apiFetch<LeadStats>('/AdminStats/GetLeadStats', { auth: true });
  },

  getUserStats: async (): Promise<UserStats> => {
    return apiFetch<UserStats>('/AdminStats/GetUserStats', { auth: true });
  }
};
